import { Shield } from 'lucide-react';
import './LoadingLogo.css';

const LoadingLogo = ({ text }) => {
  return (
    <div className="loading-logo">
      <div className="loading-logo-shield">
        <Shield size={50} />
        <span className="loading-logo-text-k">K</span>
      </div>
      <span className="loading-logo-text">RIME {text === 'map' ? 'Map' : 'Data'} Loading...</span>
    </div>
  );
};

export default LoadingLogo; 